import styled from 'styled-components';

export default styled.hr`
    --hr-color: ${({$color}) => ($color ? `var(${$color});` : 'var(--header--border-color);')}
	margin: var(--spacing-medium) 0;
    height: var(--border-width-small);
    min-height: var(--border-width-small);
    background-color: var(--hr-color);
    border: none;
`;
